import React, { useState } from 'react';
import { GOLD, BLACK } from '../../constants/theme';

interface Props {
  href?: string;
  onClick?: () => void;
  outline?: boolean;
  full?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
}

const GoldBtn: React.FC<Props> = ({ href, onClick, outline=true, full=false, children, disabled=false }) => {
  const [hov, setHov] = useState(false);
  const style: React.CSSProperties = {
    display: full ? 'block' : 'inline-block',
    width: full ? '100%' : 'auto',
    textAlign: 'center',
    padding: '14px 40px',
    border: `1px solid ${GOLD}`,
    color: outline ? (hov ? BLACK : GOLD) : BLACK,
    background: outline ? (hov ? GOLD : 'transparent') : GOLD,
    textDecoration: 'none',
    fontFamily: 'Montserrat',
    fontSize: 10,
    letterSpacing: 3,
    textTransform: 'uppercase',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s',
    opacity: disabled ? 0.7 : (!outline && hov ? 0.88 : 1),
  };
  return href
    ? <a href={href} style={style} onMouseOver={()=>setHov(true)} onMouseOut={()=>setHov(false)}>{children}</a>
    : <button disabled={disabled} onClick={onClick} style={style} onMouseOver={()=>setHov(true)} onMouseOut={()=>setHov(false)}>{children}</button>;
};

export default GoldBtn;